import React from 'react'

import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { TableRowLabelValue } from '../../../../../components/pdf/TableHelpers'
import Text from '../../../../../components/pdf/Text'
import Bar from '../../../../../components/pdf/Bar'
import View from '../../../../../components/pdf/View'
import { addBusinessDays } from '../../_helpers/pdfHelpers'
import { formatDate } from '@btime/helpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'

const Service = () => {
  const serviceOrder = useServiceOrder()
  const today = new Date()
  const expirationDate = addBusinessDays(today, 7)

  const serviceNumber = () => {
    const placeCode = serviceOrder.place.name.split(' ')[0]
    return `${placeCode}/P.${formatDate('YYYY', today)}${serviceOrder.yearlyId.split('/')[0]}`
  }

  return (
    <View>
      <Table color={'transparent'} justify="space-between" width={'100%'}>
        <TableCol color={'transparent'} width={'40%'}>
          <Table color={'transparent'} justify="space-between" width={'100%'}>
            <TableRow color={'transparent'}>
              <Text bold size="h4" align="left">
                Proposta Comercial N.º: {serviceNumber()}
              </Text>
            </TableRow>
            <TableRow color={'transparent'}>
              <TableRowLabelValue
                textAlign={'right'}
                borderColor={'transparent'}
                label={'Data'}
                value={formatDate('DD/MM/YYYY', today)}
              />
              <TableRowLabelValue
                textAlign={'right'}
                borderColor={'transparent'}
                label={'Validade'}
                value={formatDate('DD/MM/YYYY', expirationDate)}
              />
            </TableRow>
          </Table>
        </TableCol>
      </Table>
      <Bar />
    </View>
  )
}

export default Service
